import { render, staticRenderFns } from "./MemberCredential.vue?vue&type=template&id=1ca4d3aa&scoped=true"
import script from "./MemberCredential.vue?vue&type=script&lang=js"
export * from "./MemberCredential.vue?vue&type=script&lang=js"
import style0 from "./MemberCredential.vue?vue&type=style&index=0&id=1ca4d3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4d3aa",
  null
  
)

export default component.exports